/**
 * 表示されたらフェードイン
 */
const targets = document.querySelectorAll('.inview');

// hero-title は 1文字ずつ出すため事前に分割
document.querySelectorAll('.inview.hero-title').forEach((el) => {
    splitTextToChars(el);
});

// 要素があるときだけ処理を実行
if (targets.length) {
    const observer = new IntersectionObserver(
        (entries, obs) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('show');
                    obs.unobserve(entry.target);
                }
            });
        },
        {
            threshold: 0,
            // 末尾セクション（フッター直前）でも発火しやすいように調整
            rootMargin: '0px 0px -10% 0px'
        }
    );

    targets.forEach((el) => observer.observe(el));
}

function splitTextToChars(rootEl) {
    if (!(rootEl instanceof Element)) return;
    if (rootEl.dataset.splitDone === '1') return;
    rootEl.dataset.splitDone = '1';

    // reduce motion の場合は分割しない（読みやすさ優先）
    const prefersReducedMotion = window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;

    let index = 0;

    const wrapTextNode = (textNode) => {
        const text = textNode.nodeValue ?? '';
        const frag = document.createDocumentFragment();

        for (const ch of Array.from(text)) {
            if (ch === '\n') continue;

            // 各種空白（半角/全角/nbsp/ensp/emsp 等）は分割せずそのまま残す
            if (ch.trim() === '') {
                frag.appendChild(document.createTextNode(ch));
                continue;
            }

            const span = document.createElement('span');
            span.className = 'hero-char';
            span.style.setProperty('--i', String(index));
            span.textContent = ch;
            frag.appendChild(span);
            index += 1;
        }

        textNode.parentNode?.replaceChild(frag, textNode);
    };

    const walk = (node) => {
        // テキストノードを span 化
        if (node.nodeType === Node.TEXT_NODE) {
            wrapTextNode(node);
            return;
        }

        if (!(node instanceof Element)) return;
        if (node.tagName === 'BR') return;

        // 子を配列化してから走査（途中でDOMが置換されるため）
        Array.from(node.childNodes).forEach(walk);
    };

    walk(rootEl);
}